import React, { useContext, useState } from 'react';
import { CustomizeContext } from '../contexts/customize';
import MtmSize from '../components/size';
import ConfirmButton from '../common/button';
import MtmCollar from '../components/collar';
import MtmBack from '../components/back';
import MtmCuffs from '../components/cuffs';
import MtmPlackets from '../components/plackets';
import MtmPockets from '../components/pockets';
import MtmButton from '../components/button';
import MtmLabel from '../components/label';
import MtmEmbroidery from '../components/embroidery';
import MtmConfirmBtn from '../components/confirmBtn';

//FIXME
// eslint-disable-next-line no-unused-vars
const flattenObject = (ob) => {
  var toReturn = [];

  for (var i in ob) {
    // eslint-disable-next-line no-prototype-builtins
    if (!ob.hasOwnProperty(i)) continue;

    if (typeof ob[i] == 'object' && ob[i] !== null) {
      var flatObject = flattenObject(ob[i]);
      for (var x in flatObject) {
        // eslint-disable-next-line no-prototype-builtins
        if (!flatObject.hasOwnProperty(x)) continue;

        toReturn.push(flatObject[x]);
      }
    } else {
      toReturn.push(ob[i]);
    }
  }
  return toReturn;
};

const Customize = ({ onClickConfirm }) => {
  const [pocketData, setPocketData] = useState(false);
  const [placketData, setPlacketData] = useState(false);
  const { customizes } = useContext(CustomizeContext);
  console.log(customizes);
  return (
    <>
      <MtmCollar />
      <MtmBack />
      <MtmCuffs />
      <MtmPlackets setPlacketData={setPlacketData} />
      <MtmPockets setPocketData={setPocketData} />
      <MtmButton />
      <MtmSize />
      <MtmEmbroidery pocketData={pocketData} placketData={placketData} />
      <MtmLabel />
      <MtmConfirmBtn onClickConfirm={onClickConfirm} />
    </>
  );
};

export default Customize;
